import { useState } from "react";
import { initialDashboard } from "./dashboardData";

export function useDashboard() {
  const [dashboard, setDashboard] = useState(initialDashboard);

  // Add a widget to a category
  const addWidget = (categoryId, widgetName, widgetText) => {
    const newWidget = {
      id: "w" + Date.now(),
      name: widgetName,
      text: widgetText || "Widget content goes here."
    };
    setDashboard((prev) => ({
      ...prev,
      categories: prev.categories.map((cat) =>
        cat.id === categoryId
          ? { ...cat, widgets: [...cat.widgets, newWidget] }
          : cat
      )
    }));
  };

  // Remove a widget from a category
  const removeWidget = (categoryId, widgetId) => {
    setDashboard((prev) => ({
      ...prev,
      categories: prev.categories.map((cat) =>
        cat.id === categoryId
          ? { ...cat, widgets: cat.widgets.filter((w) => w.id !== widgetId) }
          : cat
      )
    }));
  };

  return { dashboard, addWidget, removeWidget };
}
